var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/redux/~/lodash/_getPrototype.js
// module id = 750
// module chunks = 0